import { i18n } from "../../../../language";

function subFormatter(value) {
    let items = value
        .map((x) => {
            let hour = Math.floor(x.value / 60 / 60);
            let min = Math.floor((x.value - hour * 60 * 60) / 60);
            let sec = Math.round(x.value - hour * 60 * 60 - min * 60);
            if (hour > 0)
                return (
                    x.marker +
                    i18n.t("message.calendarPassedTimeSec", {
                        hour,
                        min,
                        sec,
                    })
                );
            return (
                x.marker +
                i18n.t("message.calendarPassedTimeMinSec", {
                    min,
                    sec,
                })
            );
        })
        .join("<br>");

    return value[0].name + "<br>" + items;
}

export default function (data) {
    return {
        tooltip: {
            trigger: "axis",
            formatter: subFormatter,
        },
        xAxis: {
            type: "category",
            data: data.map((x) => x.name),
        },
        yAxis: {
            type: "value",
        },
        series: [
            {
                data: data.map((x) => x.value),
                type: "line",
                smooth: true,
            },
        ],
    };
}
